// extracted by mini-css-extract-plugin
module.exports = {"indicator__container":"styles_indicator__container__kz8tG","indicator__list":"styles_indicator__list__w6bf7","active":"styles_active__P7czK","indicator":"styles_indicator__2gPgs"};